const initialState = () => ({
  alert_banner_channel: { visible: false },
})

const state = initialState

export default state
